import { ArrowUp } from "lucide-react";
import { useTranslation } from "react-i18next";

const BackToTopButton = () => {
  const { t } = useTranslation();
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="flex justify-center py-12">
      <button
        onClick={scrollToTop}
        className="inline-flex items-center gap-2 glass rounded-full px-4 py-2 text-muted-foreground hover:text-primary transition-colors"
      >
        <ArrowUp className="h-4 w-4" />
        <span className="text-xs font-body">{t('common.backToTop')}</span>
      </button>
    </div>
  );
};

export default BackToTopButton;
